import { render, staticRenderFns } from "./EHR.vue?vue&type=template&id=3cd5b948"
import script from "./EHR.vue?vue&type=script&lang=js"
export * from "./EHR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports